import { Loading } from "element-ui";
let loadingInstance=null
var LoadingUtil={
    showLoading(text){
        loadingInstance = Loading.service({
            lock: true,
         //    target: document.querySelector('.base-popup-content'),
            text: text,
            background: "rgba(0,0,0,0.8)",
       });
    },
    hideLoading(){
        loadingInstance.close();
    }
}
export default LoadingUtil


// WEBPACK FOOTER //
// ./src/components/loading/loading.js